"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.HoverDesc = void 0;
const react_1 = __importDefault(require("react"));
const HoverDesc_module_scss_1 = __importDefault(require("./HoverDesc.module.scss"));
const bs_1 = require("react-icons/bs");
const react_i18next_1 = require("react-i18next");
const HoverDesc = (props) => {
    const { t, i18n } = (0, react_i18next_1.useTranslation)();
    let hasDescription = props.description !== null && props.description !== undefined;
    let isTranslated = hasDescription && i18n.exists(props.description);
    return (react_1.default.createElement(react_1.default.Fragment, null, isTranslated && (react_1.default.createElement("div", { className: `${HoverDesc_module_scss_1.default.HoverDesc}` },
        react_1.default.createElement(bs_1.BsFillInfoCircleFill, null),
        react_1.default.createElement("div", { className: HoverDesc_module_scss_1.default.description }, t(props.description))))));
};
exports.HoverDesc = HoverDesc;
//# sourceMappingURL=HoverDesc.js.map